import React from "react";


export default function NewCustomer(props) {


return(<div>NewCustomer</div>)
}